export default __webpack_public_path__ + "static/media/10.d1e1cfec.jpg";